module.exports = require("@swa-ui/locale");